import React from "react";

const SectionHeader = ({ eyebrow, title, highlight, subtitle, align = "center" }) => {
  return (
    <div className={`mb-14 ${align === "center" ? "text-center" : ""}`}>
      {eyebrow && <div className="cga-eyebrow mb-4">{eyebrow}</div>}
      <h2 className="cga-h2">
        <span className="text-white">{title} </span>
        {highlight && <span className="text-[#5eead4]">{highlight}</span>}
      </h2>
      {subtitle && (
        <p className="cga-body mt-5 max-w-3xl mx-auto">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeader;
